// getAffiliatelist

// getuserlist

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAffiliatelist, getAffiliateView ,AdminupdateAffiliatetype, exportAffiliates, updateUserStatus } from "../../Api/AdminApiCall";

export const fetchgetAffiliateApi = createAsyncThunk(
    "admin/fetchgetAffiliateApi",
    async ({ page = 1, search = '', status = '', affiliateType = '', fromDate = '', toDate = '' }, { rejectWithValue }) => {
        try {
            const res = await getAffiliatelist(page, search, status, affiliateType, fromDate, toDate);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetAdminupdateAffiliatetype = createAsyncThunk(
    "admin/fetAdminupdateAffiliatetype",
    async ( payload, { rejectWithValue }) => {
        try {
            const res = await AdminupdateAffiliatetype(payload);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);
// AdminupdateAffiliatetype

export const fetchgetAffiliateViewApi = createAsyncThunk(
    "admin/fetchgetAffiliateViewApi",
    async (id, { rejectWithValue }) => {
        try {
            const res = await getAffiliateView(id);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

// getAffiliateView

export const fetchExportAffiliatesApi = createAsyncThunk(
    "admin/fetchExportAffiliatesApi",
    async ({ search = '', status = '', affiliateType = '' }, { rejectWithValue }) => {
        try {
            const res = await exportAffiliates(search, status, affiliateType);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to export affiliates"
            );
        }
    }
);

// Update affiliate user active/inactive status
export const updateAffiliateUserStatus = createAsyncThunk(
    "admin/updateAffiliateUserStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await updateUserStatus(payload);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to update user status"
            );
        }
    }
);

const AdminAffiliateSlice = createSlice({
    name: "AdminAffiliatelist",
    initialState: {
        Affiliatelist: [],
        AffiliateView: [],
        UpdateAffiliatetype:[],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchgetAffiliateApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchgetAffiliateApi.fulfilled, (state, action) => {
                state.loading = false;
                state.Affiliatelist = action.payload;
            })
            .addCase(fetchgetAffiliateApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchgetAffiliateViewApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchgetAffiliateViewApi.fulfilled, (state, action) => {
                state.loading = false;
                state.AffiliateView = action.payload;
            })
            .addCase(fetchgetAffiliateViewApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

             .addCase(fetAdminupdateAffiliatetype.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetAdminupdateAffiliatetype.fulfilled, (state, action) => {
                state.loading = false;
                state.UpdateAffiliatetype = action.payload;
            })
            .addCase(fetAdminupdateAffiliatetype.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Update affiliate type

            // Update user active/inactive status
            .addCase(updateAffiliateUserStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAffiliateUserStatus.fulfilled, (state, action) => {
                state.loading = false;

                const updatedStatus = action.meta?.arg?.status;
                const userId = action.meta?.arg?.user_id;

                if (
                    state.Affiliatelist &&
                    Array.isArray(state.Affiliatelist.affiliates) &&
                    typeof userId !== "undefined"
                ) {
                    const target = state.Affiliatelist.affiliates.find(
                        (item) => item.id === userId || item.user_id === userId
                    );
                    if (target) {
                        target.status = updatedStatus;
                    }
                }
            })
            .addCase(updateAffiliateUserStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

const AdminAffiliateSliceReducer = AdminAffiliateSlice.reducer;

export default AdminAffiliateSliceReducer;
